// routes for WorkSchedulePrint
import { AppRouteProps } from '~/routes';
import Index from './pages/Index';
import Summary from './pages/Summary';

export default function ResourcesWorkSchedulePrint(): readonly AppRouteProps[] {
  const routes: readonly AppRouteProps[] = [
    {
      path: '/workSchedule-Print',
      component: Index,
      isProtected: true,
      permissions: ['work_schedule_printing_by_device_or_user'],
    },
    {
      path: '/workSchedule-Print/summary',
      component: Summary,
      isProtected: true,
      permissions: ['work_schedule_printing_by_device_or_user'],
    },
  ];

  return routes;
}